import React from "react";
import { Link } from "react-router-dom";
import Seo from "../../../utils/seo/Seo";
import { GUIDES_LIST } from "../../../utils/seo/guidesContent";
import "../../components/seo/seoPages.css";

export default function GuidesHub() {
  return (
    <>
      <Seo
        title="Guides: Memorial Websites & Online Remembrance"
        description="Helpful guides on creating a memorial website, virtual memorial services, digital legacy, and ideas for remembering a loved one online."
        path="/guides"
      />
      <div className="seo-page seo-page--guides">
        <h1>Guides & resources</h1>
        <p className="seo-intro">
          Practical articles for families in the United States who want to honor a loved one online—with compassion and clarity.
        </p>
        <div className="seo-guides-grid">
          {GUIDES_LIST.map((g) => (
            <article key={g.slug} className="seo-guide-card">
              <div className="seo-guide-card-body">
                <p className="seo-guide-meta">{g.readTime}</p>
                <h2 className="seo-guide-card-title">{g.title}</h2>
                <p className="seo-guide-card-desc">{g.description}</p>
              </div>
              <Link to={`/guides/${g.slug}`} className="seo-guide-read-more">
                Read more
              </Link>
            </article>
          ))}
        </div>
      </div>
    </>
  );
}
